import type { Opportunity } from "@entities";
import type { ColumnProps } from "@shared/frontend/hyper-table";
import { formatOpportunitySchedule } from "@shared/helpers/format-opportunity-schedule";
import OpportunityTitle from "../../../components/table/opportunity-title/OpportunityTilte";

export const useSelectOpportunitiesColumns = (): ColumnProps<Opportunity>[] => {
  return [
    {
      field: "title",
      cell: ({ row, column }) => {
        return <OpportunityTitle column={column} row={row} />;
      },
      enableSorting: false,
    },
    {
      field: "endDate",
      caption: "מועד",
      valueConverter: (row) => formatOpportunitySchedule(row),
    },
    {
      field: "participantsCount",
    },
    {
      field: "amount",
    },
    { field: "isRepeated" },
    { field: "isPublic" },
    { field: "location" },
    { field: "comments" },
    { field: "createdAt", caption: "נוצר בתאריך", valueConverter: (row) => row.createdAt?.toLocaleDateString("he") ?? "-" },
    { field: "updatedAt", caption: "עודכן בתאריך", valueConverter: (row) => row.updatedAt?.toLocaleDateString("he") ?? "-" },
  ];
};
